import { addSpotsAction } from "fleet/redux-store/ui-state/strategy-v2";
import { connect } from "react-redux";
import { getAllByIdExceptSzs } from "redux-store/applications/selectors";
import { addSuccessMessageAction } from "redux-store/messages";

import { AddSpotMediaTableController } from "./add-spot-media-table-controller";

function mapStateToProps(state) {
  const { app, global } = state;

  return {
    applications: getAllByIdExceptSzs(global.applications),
    contentFolders: app.contentFolders,
    contentGroups: app.contentGroups,
    userContents: global.userContents,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addSpots: (payload) => {
      dispatch(addSpotsAction(payload));
      dispatch(addSuccessMessageAction("Success! Added to strategy."));
    },
  };
}

const ConnectedAddSpotMediaTable = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddSpotMediaTableController);

export { ConnectedAddSpotMediaTable };
